module.exports = __webpack_public_path__ + "img/Super_Tracker_Logo_White.68b34200.svg";